import Vue from 'vue';

Vue.component('configurator-model-select', {
    props: {
        cdnUrl: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            selectionExpanded: false,
        };
    },

    computed: {
        makeBoxModelActive() {
            return this.selectionExpanded ? 'active' : '';
        },
    },

    methods: {
        /**
         * Track model selection if any tracker who wants it is loaded.
         *
         * @param {String} model
         * @return {Void}
         */
        trackModelSelection(model) {
            if (typeof p161 === 'object') {
                let pixelId = '';
                if (this.$parent.siteHandle === 'mgMotorsNetherlands') {
                    pixelId = '3161288';
                }
                if (this.$parent.siteHandle === 'mgMotorsNorway') {
                    pixelId = '3161319';
                }
                if (pixelId !== '') {
                    p161.track(pixelId, { customer_extra: model });
                    if (typeof window.trackQueue === 'function') {
                        window.trackQueue(p161);
                    }
                }
            }
        },

        selectModel(car) {
            this.trackModelSelection(car.commerceHandle);
            this.$parent.handleSelectModel(car.slug);
        },

        getModelSelectTitle(selectedModel) {
            const isHs = ['hs', 'mg-hs-2023'].includes(selectedModel);
            const isMgStartOfName =
                selectedModel.title.slice(0, 2).toLowerCase() === 'mg';

            if (this.siteHandle === 'mgMotorsSpain' && isHs) {
                return 'Nuevo MG HS';
            }
            return isMgStartOfName
                ? selectedModel.title
                : `MG ${selectedModel.title}`;
        },

        getModelName(carTitle) {
            const slicedCarTitle = carTitle.slice(0, 2).toUpperCase();
            const hasNumber = carTitle.match(/\d+/);
            if (hasNumber != null) {
                return {
                    modelTitle: slicedCarTitle,
                    modelNumber: carTitle[2],
                };
            }

            return {
                modelTitle: `MG ${carTitle}`,
                modelNumber: '',
            };
        },

        getImagePath(carCommerceHandle) {
            return `${this.cdnUrl}/images/configurator/model-switch/${carCommerceHandle}.png`;
        },
    },
});
